import BaseReducer from "../../utilities/BaseReducer";
import IAction from "../../models/IAction";
import ResponseEsitoModel from "stores/shared/models/ResponseEsitoModel";
import PraticaAction from "./PraticaAction";
import IPraticaState from "./models/IPraticaState";
import PraticaInfoPraticaRequestModel from "./models/PraticaInfoPraticaRequestModel";

export default class PraticaReducer extends BaseReducer<IPraticaState> {
    public readonly initialState: IPraticaState = {
        responseCreaPratica: false,
        pratica: new PraticaInfoPraticaRequestModel({}),
    };

    public [PraticaAction.REQUEST_CREA_PRATICA_CQSOL_FINISHED](
        state: IPraticaState,
        action: IAction<ResponseEsitoModel>
    ): IPraticaState {
        return {
            ...state,
            responseCreaPratica: action.payload!.esito,
        };
    }

    public [PraticaAction.REQUEST_INFO_PRATICA_CQSOL_FINISHED](
        state: IPraticaState,
        action: IAction<PraticaInfoPraticaRequestModel>
    ): IPraticaState {
        return {
            ...state,
            pratica: {
                ...action.payload!,
            } as PraticaInfoPraticaRequestModel,
        };
    }
}
